import classNames from 'classnames';
import { Typography } from '../../../../../components/typography/typography';
import { PropsWithChildren, ReactNode } from 'react';
import styles from './product-item.module.css';

export const ProductItemProperty = ({
  header,
  containerClassName = styles.fieldContainer,
  headerClassName,
  contentClassName,
  children,
  action,
  selfEnd = false,
}: PropsWithChildren<{
  header: string;
  containerClassName?: string;
  headerClassName?: string;
  contentClassName?: string;
  action?: ReactNode;
  selfEnd?: boolean;
}>) => {
  return (
    <div className={classNames(containerClassName)}>
      <div className={classNames(styles.fieldHeader, headerClassName)}>
        <Typography
          type="text-sm"
          weight="regular"
          dataCy="product-item-property-header"
          className={classNames(styles.fieldHeaderLabel, {
            [styles.labelSelfEnd]: selfEnd,
          })}
        >
          {header}
        </Typography>

        {action}
      </div>
      <div
        data-cy="product-item-property-content"
        className={classNames(contentClassName, styles.fieldContent, {
          [styles.contentSelfEnd]: selfEnd,
        })}
      >
        {children}
      </div>
    </div>
  );
};
